import "./auth.scss";
import React from "react";
import LoginForm from "../../components/Forms/AuthForms/LoginForm";
import onco_mark from "../../assets/logos/ONCOEVIDA_1.png";

const Login = () => {
  return (
    <div className="myCustomLogin">
      <div className="logoPart container">
        <div className="logoContainer">
          <img src={onco_mark} alt="" style={{ width: "50%" }} />
        </div>
        <h2 className="form-header mt-2">Welcome to OncoEvida</h2>
        <p className="form-desc">Please sign in to see your dashboard.</p>
      </div>
      <div className="formPart">
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;
